import { combineReducers } from '@reduxjs/toolkit';

import elhaghiyehHaSlice from 'Feature/Common/ElhaghiyehHa/Actions/reducer';
import insuranceModuleSlice from 'Shared/InsuranceModules/reducers/insuranceModuleSlice';
import menuCategorySlice from 'Shared/MenuCategories/reducers/menuCategorySlice';

import addressSlice from './addressReducer/addressSlice';
import misDiscountCodeSlice from './misDiscountCodeReducer/misDiscountCodeSlice';

export const commonReducers = combineReducers({
  address: addressSlice,
  misDiscountCode: misDiscountCodeSlice,
  insuranceModules: insuranceModuleSlice,
  menuCategory: menuCategorySlice,
  elhaghiyehHa: elhaghiyehHaSlice,
});
